import { FormEvent, useState } from "react";
import { LockKeyhole } from "lucide-react";

interface LoginScreenProps {
  isLoading: boolean;
  errorMessage: string | undefined;
  onLogin: (password: string) => void;
}

export function LoginScreen({ isLoading, errorMessage, onLogin }: LoginScreenProps) {
  const [password, setPassword] = useState("");

  function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    onLogin(password);
  }

  return (
    <main className="login-shell">
      <form className="login-panel" onSubmit={handleSubmit}>
        <div className="login-icon" aria-hidden="true">
          <LockKeyhole size={22} />
        </div>
        <h1>Quotation Workspace</h1>
        <label className="field" htmlFor="web-password">
          <span>Password</span>
          <input
            id="web-password"
            type="password"
            value={password}
            autoComplete="current-password"
            autoFocus
            onChange={(event) => setPassword(event.currentTarget.value)}
          />
        </label>
        <button
          type="submit"
          className="primary-button"
          disabled={isLoading || password.trim().length === 0}
        >
          {isLoading ? "Signing in" : "Sign in"}
        </button>
        {errorMessage && <p className="error-text">{errorMessage}</p>}
      </form>
    </main>
  );
}
